var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodsInTrustLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#FCEBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6476 40.1709H71.5479V42.2314H75.6476V40.1709Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2951 40.1709H24.1953V42.2314H28.2951V40.1709Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0489 19.3594H48.999V23.4805H51.0489V19.3594Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6419 21.5108L26.1924 22.9678L29.0913 25.8818L30.5408 24.4248L27.6419 21.5108Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3482 21.5225L69.4492 24.4365L70.8987 25.8935L73.7976 22.9795L72.3482 21.5225Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4089 46.3526C49.8189 46.3526 50.2289 46.1465 50.2289 45.9404L55.3536 37.6982L53.5087 36.668L48.999 43.8799L46.7441 42.2315L45.5142 43.6738L48.794 46.1465C48.999 46.3526 49.2039 46.3526 49.4089 46.3526Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.395 55.625H67.448V26.7773H32.395V55.625ZM40.5945 35.6377C44.0793 35.0195 47.3592 33.3711 50.024 30.6924C52.4839 33.1651 55.7637 35.0195 59.4535 35.6377L60.4784 35.8438C59.8634 41.4073 56.7886 46.5586 52.2789 49.8555L50.024 51.5039L48.3841 50.2676C43.6694 46.9707 40.5945 41.6133 39.7746 35.8438L40.5945 35.6377Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0708 82H29.3202V66.5459H19.0708V82ZM23.1706 76.8486H25.2204V78.9092H23.1706V76.8486Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9523 58.3035C79.1324 57.6853 77.9024 57.6853 77.0825 58.3035L67.0381 67.3699C66.2181 68.1941 64.9882 68.8123 63.9632 69.2244L56.3787 72.3152C55.5587 72.7273 54.7388 72.5213 54.1238 71.9031L51.8689 69.6365L60.0685 66.1336C60.8884 65.5154 61.7084 64.8972 62.1183 64.073C62.7333 63.0427 62.3233 61.8064 61.2984 61.1882C60.8884 60.9822 60.2734 60.7761 59.8635 60.9822L48.3841 63.0427C46.9492 63.2488 45.7193 63.867 44.4894 64.4851L40.3896 67.1638C38.7497 68.1941 36.6998 68.8123 34.6499 68.8123H31.3701V80.3514L35.8799 79.9392C37.3148 79.7332 38.5447 79.9392 39.7746 80.3514L43.8744 81.5877C44.8993 81.7937 45.7193 81.9998 46.7442 81.9998H52.4839C53.9188 81.9998 55.5587 81.5877 56.9936 80.9695L67.448 76.2303C68.883 75.6121 70.3179 74.5818 71.3428 73.1394L80.1573 62.0125C80.7723 61.1882 80.7723 59.7459 79.9523 59.1277V58.3035Z",
    fill: "#F78670"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsInTrustLg);
export default __webpack_public_path__ + "static/media/goodsInTrustLg.9846e7c20de9ae189dfde9906b9317e9.svg";
export { ForwardRef as ReactComponent };